/* RESPONSIBLE TEAM: team-inbox-management */
import Helper from '@ember/component/helper';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

const IconMap: Record<string, InterfaceIconName | undefined> = {
  messenger: 'messenger',
  whatsapp: 'whatsapp',
  facebook: 'facebook',
  twitter: 'twitter',
  instagram: 'instagram',
  sms: 'sms',
  email: 'email',
  phone_call: 'phone',
  ios: 'ios',
  android: 'android',
  zendesk_ticket: 'ticket',
  zendesk_sunshine: 'messenger',
  salesforce_case: 'ticket',
  slack: 'slack',
  discord: 'discord',
  telegram: 'telegram',
  fin_agent_api: 'fin',
};

export default class LookupChannelIconFromName extends Helper<{
  Args: {
    Positional: [string | undefined];
  };
  Return: InterfaceIconName | undefined;
}> {
  compute(params: [string | undefined]) {
    let [channelName] = params;

    if (!channelName) {
      return undefined;
    }

    return IconMap[channelName];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'lookup-channel-icon-from-name': typeof LookupChannelIconFromName;
  }
}
